import { SyntheticEvent, useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import useUsers from 'api/useUsers';
import { EFeatureFlag } from 'constants/enums';
import { TabsPanel } from 'design-system/TabPanel/TabPanel';

import PageTopBar from 'components/Topbar/PageTopBar';

const TAB_BUSINESS = 'Business';
const TAB_FINANCE = 'Finance';
const TAB_AB_TEST = 'A/B Test'

export enum EAnalyticsState {
  BUSINESS = 'business',
  FINANCE = 'finance',
  AB_TEST = 'ab-test',
}

const AnalyticsView: React.FC = () => {
  const { publisherId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;
  const getCurrentTab = (): EAnalyticsState => {
    if (currentPath.includes('/finance')) return EAnalyticsState.FINANCE;
    if (currentPath.includes('/ab-test')) return EAnalyticsState.AB_TEST;
    return EAnalyticsState.BUSINESS;
  };

  const [tab, setTab] = useState<EAnalyticsState>(getCurrentTab());

  const { fetchFeatureFlags } = useUsers({ publisherId });
  const shouldDisplaySciPlayAnalytics =
    fetchFeatureFlags.data?.featureFlags?.[
      EFeatureFlag.CHECKOUT_SCIPLAY_ANALYTICS
    ];

  const basePath = `/project/${publisherId}`;
  const getAnalyticsPath = (basePath: string, state: EAnalyticsState) =>
    `${basePath}/statistics/${state}`;

  const handleTabChange = (event: SyntheticEvent, newValue: EAnalyticsState) => {
    setTab(newValue);
    navigate(getAnalyticsPath(basePath, newValue));
  };

  const tabs = [
    { label: TAB_BUSINESS, value: EAnalyticsState.BUSINESS },
    ...(shouldDisplaySciPlayAnalytics ? [{ label: TAB_FINANCE, value: EAnalyticsState.FINANCE }] : []),
    { label: TAB_AB_TEST, value: EAnalyticsState.AB_TEST },
  ];

  if (fetchFeatureFlags.data?.featureFlags === undefined) {
    return <></>;
  }

  return (
    <TabsPanel
      tabs={tabs}
      headerComponent={<PageTopBar withTabsDesign={true} headline="Analytics" />}
      handleTabChange={handleTabChange}
      activeTabVal={tab}
    />
  );
};

export default AnalyticsView;
